// extracted by mini-css-extract-plugin
module.exports = {"container":"Notifs_container__3Ic1H","notif":"Notifs_notif__EeGCT","new":"Notifs_new__3uvqx","puce":"Notifs_puce__2NAR7"};